import { useEffect, useState } from 'react';
import bgImage from "./assets/blog-hero-img.png";

const BlogHero = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Trigger animations only once on page load
    setVisible(true);
  }, []);

  return (
    <section
      className={`relative min-h-screen bg-cover bg-center flex items-center justify-start px-6 md:px-16 transition-opacity duration-1000 ${
        visible ? 'opacity-100' : 'opacity-0'
      }`}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .fade-in {
          animation: fadeIn 1s ease-out forwards;
        }
      `}</style>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#000B2E]/80 to-[#000B2E]/80 z-0" />

      {/* Content */}
      <div className="relative z-10 w-full text-center">
        <h1
          className={`text-white font-bold text-[38px] sm:text-[48px] md:text-[60px] lg:text-[76px] leading-tight font-satoshi mb-4 ${
            visible ? "fade-in" : ""
          }`}
          style={{ animationDelay: "0.2s" }}
        >
          Blue Bulletin <br />
          <span className="text-[#00B2FF]">Blogs</span>
        </h1>
      </div>
    </section>
  );
};

export default BlogHero;